import { STORE_SCREENSHOTS } from "../data/content";
import useReveal from "../hooks/useReveal";

/**
 * Section 3 — Four store screenshots in a row, each with a short caption.
 * Collapses cleanly to 2-up on tablet and stacked on mobile.
 */
export default function ScreenshotsRow() {
  const headRef = useReveal();
  return (
    <section
      id="screens"
      data-testid="screenshots-section"
      className="relative bg-[#0a0d08] border-t border-white/5"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-24 lg:py-32">
        <div ref={headRef} className="reveal max-w-2xl mb-16 lg:mb-20">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-body">
            Features
          </p>
          <h2
            data-testid="screenshots-title"
            className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl text-white text-balance"
          >
            A look inside the wild.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {STORE_SCREENSHOTS.map((s, i) => (
            <Card key={s.title} item={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Card({ item, index }) {
  const ref = useReveal();
  return (
    <article
      ref={ref}
      data-testid={`screenshot-card-${index}`}
      style={{ transitionDelay: `${index * 90}ms` }}
      className="reveal group"
    >
      <div className="overflow-hidden rounded-2xl border border-white/10 bg-[hsl(var(--card))] shadow-xl shadow-black/40 transition-all duration-500 group-hover:border-[hsl(var(--primary))]/40 group-hover:-translate-y-1 group-hover:shadow-[hsl(var(--primary))]/15">
        <div className="aspect-[9/16] overflow-hidden bg-black">
          <img
            src={item.src}
            alt={item.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]"
          />
        </div>
      </div>
      <div className="mt-5 px-1">
        <h3
          className="font-display text-2xl text-white"
          data-testid={`screenshot-title-${index}`}
        >
          {item.title}
        </h3>
        <p
          className="mt-2 text-sm text-white/65 leading-relaxed font-body"
          data-testid={`screenshot-caption-${index}`}
        >
          {item.caption}
        </p>
      </div>
    </article>
  );
}
